module.exports = __webpack_public_path__ + "img/monthly-report-mobile.5772ccc3.png";